import { render, staticRenderFns } from "./CrossOrderDetail.vue?vue&type=template&id=960597a6&scoped=true&"
import script from "./CrossOrderDetail.vue?vue&type=script&lang=js&"
export * from "./CrossOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./CrossOrderDetail.vue?vue&type=style&index=0&id=960597a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960597a6",
  null
  
)

export default component.exports